import { Controller } from "@hotwired/stimulus"

// « Par classe » of « Suivi de solvabilité » (28/10/2026): the chevron of a class unfolds its
// students under its row. The first click fetches them (a turbo stream that inserts the rows
// after the class's row, on the table's settings and columns); the next ones hide and show them.
export default class extends Controller {
  static targets = ["chevron"]
  static values = { url: String, classroom: String, showLabel: String, hideLabel: String }

  toggle(event) {
    event.preventDefault()
    if (this.loading) return

    const open = this.element.getAttribute("aria-expanded") !== "true"
    if (open && !this.loaded) return this.load()

    this.rows().forEach(row => { row.hidden = !open })
    this.render(open)
  }

  load() {
    this.loading = true
    this.element.setAttribute("aria-busy", "true")
    fetch(this.urlValue, { headers: { "Accept": "text/vnd.turbo-stream.html", "X-Requested-With": "XMLHttpRequest" } })
      .then(response => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return response.text()
      })
      .then(html => {
        Turbo.renderStreamMessage(html)
        this.loaded = true
        this.render(true)
      })
      .catch(error => console.error("recovery-unfold:", error))
      .finally(() => {
        this.loading = false
        this.element.removeAttribute("aria-busy")
      })
  }

  rows() {
    return document.querySelectorAll(`[data-recovery-child="${this.classroomValue}"]`)
  }

  render(open) {
    this.element.setAttribute("aria-expanded", open ? "true" : "false")
    const label = open ? this.hideLabelValue : this.showLabelValue
    this.element.setAttribute("aria-label", label)
    this.element.setAttribute("title", label)
    if (this.hasChevronTarget) this.chevronTarget.style.transform = open ? "rotate(90deg)" : ""
  }
}
